import { render, staticRenderFns } from "./NMALevyData.vue?vue&type=template&id=2bc5595e"
import script from "./NMALevyData.vue?vue&type=script&lang=js"
export * from "./NMALevyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports